import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags } from '@lezer/highlight';
import { EditorView } from '@codemirror/view';

import type { Extension } from '@codemirror/state';

import { ERROR_LINE_CLASS, ERROR_LINE_GUTTER_CLASS } from './html-validation-extension';

const LIGHT_TEXT = '#0A0B0D';
const LIGHT_ANGLE_BRACKET = '#0A0B0D';
const LIGHT_TAG_NAME = '#0F766E';
const LIGHT_ATTRIBUTE_NAME = '#B45309';
const LIGHT_STRING = '#085';
const LIGHT_COMMENT = '#6a737d';
const LIGHT_NUMBER = '#0369A1';
const LIGHT_LIQUID_TAG = '#A21CAF';
const LIGHT_LIQUID_VARIABLE = '#3D3CC2';

const LIGHT_CSS_PROPERTY = '#BE123C';
const LIGHT_CSS_UNIT = '#A21CAF';
const LIGHT_CSS_VALUE = '#0F766E';
const LIGHT_CSS_CLASS_NAME = '#3D3CC2';
const LIGHT_CSS_COLOR = '#0369A1';

const lightHighlightStyle = HighlightStyle.define([
  { tag: tags.keyword, color: LIGHT_TEXT },
  { tag: tags.tagName, color: LIGHT_TAG_NAME },
  { tag: tags.attributeName, color: LIGHT_ATTRIBUTE_NAME },
  { tag: tags.attributeValue, color: LIGHT_STRING },
  { tag: tags.string, color: LIGHT_STRING },
  { tag: tags.comment, color: LIGHT_COMMENT },
  { tag: tags.number, color: LIGHT_NUMBER },
  { tag: tags.typeName, color: LIGHT_TAG_NAME },
  { tag: tags.angleBracket, color: LIGHT_ANGLE_BRACKET },
  { tag: tags.operator, color: LIGHT_TEXT },
  { tag: tags.punctuation, color: LIGHT_TEXT },
  { tag: tags.content, color: LIGHT_TEXT },
  { tag: tags.propertyName, color: LIGHT_CSS_PROPERTY },
  { tag: tags.unit, color: LIGHT_CSS_UNIT },
  { tag: tags.atom, color: LIGHT_CSS_VALUE },
  { tag: tags.className, color: LIGHT_CSS_CLASS_NAME },
  { tag: tags.color, color: LIGHT_CSS_COLOR },
]);

export const baseThemeExtension: Extension = EditorView.theme({
  '&': {
    height: '100%',
  },
  '.cm-scroller': {
    overflow: 'auto',
  },
  '.cm-tooltip-autocomplete > ul': {
    fontFamily: 'system-ui, sans-serif',
    maxHeight: '250px',
    overflowY: 'auto',
  },
  '.cm-tooltip-autocomplete > ul > li': {
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
  },
  '.cm-completionDetail': {
    marginLeft: '8px',
    fontSize: '12px',
  },
});

export const lightThemeExtension: Extension = [
  EditorView.theme({
    '.cm-content': {
      color: LIGHT_TEXT,
    },
    '.cm-liquid-tag': {
      color: LIGHT_LIQUID_TAG,
    },
    '.cm-liquid-variable': {
      color: LIGHT_LIQUID_VARIABLE,
    },
    '.cm-css-property': {
      color: LIGHT_CSS_PROPERTY,
    },
    '.cm-css-value': {
      color: LIGHT_CSS_VALUE,
    },
    '.cm-css-number': {
      color: LIGHT_NUMBER,
    },
    '.cm-css-unit': {
      color: LIGHT_CSS_UNIT,
    },
    '.cm-css-color': {
      color: LIGHT_NUMBER,
    },
    '.cm-tooltip-autocomplete': {
      background: '#ffffff',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
    '.cm-tooltip-autocomplete > ul > li[aria-selected]': {
      background: '#dbeafe',
      color: '#1f2937',
    },
    '.cm-completionDetail': {
      color: '#6b7280',
    },
    [`.${ERROR_LINE_CLASS}`]: {
      backgroundColor: 'var(--red-100)',
    },
    [`.${ERROR_LINE_GUTTER_CLASS}`]: {
      backgroundColor: 'var(--red-100)',
      color: 'var(--red-700)',
    },
  }),
  syntaxHighlighting(lightHighlightStyle),
];
